module.exports = __webpack_public_path__ + "img/icon_赛事等级徽章_A级@3x.a8e34611.png";